<template>
  <div>
    <b-container>
      <div
        v-if="$route.query.profile"
        class="d-flex text-center align-items-center top-div"
      >
        <router-link button to="/profile">
          <b-icon icon="arrow-left-short"></b-icon>
        </router-link>
        <h5>
          <b>{{ $route.query.profile }}</b>
        </h5>
      </div>
      <b-row>
        <b-col md="12">
          <b-table
            :items="listData"
            :fields="fields"
            hover
            responsive
            class="wishlis-table mt-3"
          >
            <template #cell(productImage)="{ item }">
              <b-img
                :src="item.images.bigImage"
                class="wishlist-img img-fluid"
                alt="img"
              ></b-img>
            </template>

            <template #cell(description)="{ item }">
              <div>
                <h6 class="mt-0 mb-1">
                  {{ item.description_summary }}
                </h6>
                <!-- <p class="mb-1 text-uppercase text-muted">
                  {{ item.Brand }}
                </p> -->
                <!-- <p class="mb-0">
                  Provider :
                  <router-link
                    :to="{
                      path: `/shopDetails/${item.provider}/${item.providerName}`,
                    }"
                  >
                    {{ item.providerName }}
                  </router-link>
                </p> -->
              </div>
            </template>

            <template #cell(price)="{ item }">
              <h6 class="text-icon price-normal mb-0">
                {{ currency.symbol }} {{ item.Price }}
              </h6>
            </template>

            <template #cell(status)="{ item }">
              <h5
                class="mb-0"
                :class="item.Availability.toLowerCase().replace(/\s/g, '')"
              >
                {{ formatAvailability(item.Availability) }}
              </h5>
            </template>

            <template #cell(actions)="{ item }">
              <div class="d-flex justify-content-center align-items-center">
                <template
                  v-if="
                    $options.components['checkout-increment-decrement'] &&
                    item.Availability.toLowerCase().trim() !== 'out of stock'
                  "
                >
                  <checkout-increment-decrement
                    class="wishlist-actions"
                    :callCheckout="true"
                    :cartItem="item"
                  />
                </template>
                <b-button
                  class="text-dark ml-1 removeWishBtn"
                  variant="outline-danger"
                  @click="removeToWishList(item)"
                >
                  <b-icon icon="x-circle" class=""></b-icon>
                </b-button>
              </div>
            </template>
          </b-table>
          <b-col
            md="12"
            :style="{ display: listData.length === 0 ? '' : 'none' }"
            class="text-center"
          >
            <div class="text-center">
              <b-img inline src="img/empty-wishlist.png" fluid></b-img>
              <h3 class="font-weight-bold mb-4 mt-4">
                {{ $t("wishlistProduct.empty") }}
              </h3>
              <b-navbar-brand>
                <b-button
                  @click="$router.push('/')"
                  variant="primary"
                  class="mb-2"
                  >{{ $t("wishlistProduct.continueShopping") }}</b-button
                >
              </b-navbar-brand>
            </div>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "wishlist",
  data() {
    return {
      fields: [
        { key: "productImage", label: "PRODUCT", class: "text-center" },
        { key: "description", label: "DESCRIPTION", class: "text-left" },
        { key: "price", label: "PRICE", class: "text-center" },
        { key: "status", label: "STOCK STATUS", class: "text-center" },
        { key: "actions", label: "ACTIONS", class: "text-center" },
      ],
      isLoading: false,
    };
  },

  computed: {
    ...mapState({
      listData: (state) => state.wishlist.listData,
      cartData: (state) => state.checkout.cartData,
      currency: (state) => state.home.currency,
      isLoggedin: (state) => state.auth.isLoggedin,
    }),
  },
  props: {
    callCheckout: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions({
      fetchWishlist: "wishlist/listWishList",
    }),
    formatAvailability(text) {
      const cleaned = text.trim().toUpperCase();
      if (cleaned === "INSTOCK") return "IN STOCK";
      if (cleaned === "OUTOFSTOCK") return "OUT OF STOCK";
      return text;
    },
    async addtowishlist(item) {
      try {
        if (this.cartData.length > 0) {
          if (this.cartData[0].provider == item.provider) {
            await this.$store.dispatch("checkout/increaseCartQty", {
              cartItem: item,
              callApi: this.callCheckout,
            });
            this.loading = false;
            if (this.callCheckout)
              await this.$store.dispatch("checkout/checkoutFinal");
          } else {
            this.$swal({
              title: `Sure??`,
              text: this.$t("swal.diffrentSeller"),
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Yes",
            }).then(async (result) => {
              if (result.value) {
                await this.$store.dispatch("checkout/clearCart");
                await this.$store.dispatch("checkout/increaseCartQty", {
                  cartItem: item,
                  callApi: this.callCheckout,
                });
                await this.$store.dispatch("wishlist/removeToWishList", item);
                await this.fetchWishlist();
              }
              this.loading = false;
            });
          }
        } else {
          await this.$store.dispatch("checkout/increaseCartQty", {
            cartItem: item,
            callApi: this.callCheckout,
          });
          await this.$store.dispatch("wishlist/removeToWishList", item);
          await this.fetchWishlist();
          this.loading = false;
          if (this.callCheckout)
            await this.$store.dispatch("checkout/checkoutFinal");
        }
      } catch {
        this.loading = false;
      }
    },
    async removeToWishList(productData) {
      this.isLoading = true;
      await this.$store.dispatch("wishlist/removeToWishList", productData);
      this.$swal({
        group: "item",
        title: this.$t("swal.title"),
        text: this.$t("swal.itemRemoved"),
        type: "success",
        timer: 1000,
      });
      await this.fetchWishlist();
      this.isLoading = false;
    },
  },

  async mounted() {
    if (this.isLoggedin) await this.fetchWishlist();
  },
};
</script>
<style scoped>
.instock {
  color: green;
}
.outofstock {
  color: red;
}

.bi-arrow-left-short {
  height: 3rem;
  width: 3rem;
  color: var(--primarycolor);
  padding: 0px;
}

.bi-arrow-left-short:hover {
  color: var(--darkcolor);
}
.wishlist-img {
  max-width: 80px;
  height: 80px;
  object-fit: contain;
  margin-right: 10px;
  text-align: center;
}
.wishlistHeading {
  font-size: 2rem;
  font-weight: 600;
}
::v-deep .wishlis-table table {
  border: 1px solid #ddd;
  border-radius: 8px;
}
::v-deep .wishlis-table table th {
  border-bottom: none;
}
::v-deep .wishlis-table .b-table tr th div {
  font-size: 0.875rem;
  font-weight: 500;
}
::v-deep .wishlis-table .b-table tr td {
  vertical-align: middle;
}
.inStock {
  color: #2c742f;
  font-size: 0.875rem;
  font-weight: 400;
  background: #20b52633;
  padding: 4px 8px;
  border-radius: 4px;
  width: 90px;
  margin: 0 auto;
}
.outOfStock {
  color: #ea4b48;
  font-size: 0.875rem;
  font-weight: 400;
  background: #ea4b4833;
  padding: 4px 8px;
  border-radius: 4px;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.addToWishBtn {
  font-weight: 500;
  /* color: var(--primarylight); */
  /* color: #fff; */
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background: var(--primarycolor);
  border: 1px solid var(--darkcolor);
  padding: 0.375rem 0.625rem;
  font-size: 0.6875rem;
  line-height: 1.5;
  border-radius: 1.4375rem;
  text-transform: capitalize;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.removeWishBtn {
  border: none;
  background: transparent;
  color: var(--secondary);
}
::v-deep .wishlist-actions p {
  margin: 0;
}
::v-deep .wishlist-actions .product-add:hover {
  font-weight: 500 !important;
}
@media (max-width: 768px) {
  h3 {
    font-size: 1.5rem;
  }

  .wishlist-table {
    overflow-x: auto;
  }

  .wishlist-img {
    max-width: 60px;
    max-height: 60px;
  }

  .text-center {
    text-align: center !important;
  }

  .mt-4,
  .pt-4 {
    margin-top: 1rem !important;
    padding-top: 1rem !important;
  }
}

@media (max-width: 576px) {
  h3 {
    font-size: 1.2rem;
  }

  .wishlist-img {
    max-width: 50px;
    max-height: 50px;
  }

  .wishlist-table {
    font-size: 0.875rem;
  }

  .text-center {
    font-size: 0.9rem;
  }
}
</style>
